// src/contexts/AdContext.js
import { createContext, useState, useContext, useCallback } from 'react';

const AdContext = createContext(null);

export const useAd = () => {
  return useContext(AdContext);
};

export const AdProvider = ({ children }) => {
  const [isAdVisible, setIsAdVisible] = useState(true);

  /**
   * ログインユーザーとトーナメントオーナーの階層に基づいて広告の表示/非表示を更新する
   * @param {object | null} currentUser - 現在ログインしているユーザーのオブジェクト
   * @param {string | null} ownerTier - トーナメントオーナーの階層（'free', 'paid'など）
   */
  const updateAdVisibility = useCallback((currentUser, ownerTier) => {
    const isCurrentUserPaid = currentUser && currentUser.tier !== 'free';
    const isOwnerPaid = ownerTier !== 'free';

    if (isCurrentUserPaid || isOwnerPaid) {
      setIsAdVisible(false);
    } else {
      setIsAdVisible(true);
    }
  }, []);

  const value = {
    isAdVisible,
    updateAdVisibility,
  };

  return (
    <AdContext.Provider value={value}>
      {children}
    </AdContext.Provider>
  );
};